document.addEventListener("DOMContentLoaded", function () {
    var video = document.querySelector("[id^='Mp4Video-']");
    if (!video) return;

    var video480p = video.getAttribute("data-video-480p");
    var video720p = video.getAttribute("data-video-720p");
    var videoOriginal = video.getAttribute("data-video-original");

    var heroContainer = video.closest('.hero');

    function updateVideoSource() {
        var width = window.innerWidth;
        var newSrc = "";

        if (width <= 480) {
            newSrc = video480p || video720p || videoOriginal;
        } else if (width <= 768) {
            newSrc = video720p || videoOriginal;
        } else {
            newSrc = videoOriginal;
        }

        if (video.src !== newSrc && newSrc) {
            video.src = newSrc;

            // 监听视频数据足够播放
            video.addEventListener('canplaythrough', function onCanPlay() {
                if (heroContainer) {
                    heroContainer.classList.add('video-loaded');
                }
                video.play().catch(() => {
                    video.setAttribute("controls", "");
                });
                video.removeEventListener('canplaythrough', onCanPlay);
            }, { once: true });

            video.load();
        } else {
            // src 未变，尝试确保播放
            if (heroContainer && !heroContainer.classList.contains('video-loaded')) {
                video.play().then(() => {
                    heroContainer.classList.add('video-loaded');
                }).catch(() => {
                    video.setAttribute("controls", "");
                });
            }
        }
    }

    updateVideoSource();
    window.addEventListener("resize", updateVideoSource);
});